import React from 'react';
import { InfiniteScrollProps } from './types';
import useInfiniteScroll from './useInfiniteScroll';

export interface Props extends InfiniteScrollProps {
  children: any;
}

const InfiniteScroll = ({ children, ...props }: Props) => {
  const infiniteRef = useInfiniteScroll({
    ...props,
    debounceInterval: 500,
  });

  return (
    <div style={{ width: '100%' }} ref={infiniteRef}>
      {children}
    </div>
  );
};

export default InfiniteScroll;
